/* ==========================================================================
   MM Sélecteur Pays / Langue — Modale
   Ouverture/fermeture + auto-détection au 1er visit (modale seule, pas de
   redirect client : les redirections de market sont gérées server-side par
   Shopify Markets, SEO-safe).
   ========================================================================== */
(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {
		const modalContainer = document.querySelector('[data-mm-selector-modal-container]');
		if (!modalContainer) return;

		const html = document.documentElement;
		const focusTrap = {};
		let inertElements = [];

		// Dialogue modal (WCAG 2.4.3, 2.1.2) : focus dans la modale, Tab qui boucle,
		// reste de la page inerte, focus rendu a l'element d'origine a la fermeture.
		const openModal = () => {
			if (modalContainer.classList.contains('mm-open')) return;
			const trigger = document.activeElement;
			if (window.mmCloseMobileMenu) window.mmCloseMobileMenu();
			if (window.mmHideSearch) window.mmHideSearch();
			if (window.hideBgFilter) window.hideBgFilter();
			if (window.NavigationManager) window.NavigationManager.closeAllMegaMenus();

			modalContainer.classList.add('mm-open');
			html.classList.add('stop-scrolling');

			inertElements = Array.from(document.body.children).filter(
				(el) => !el.contains(modalContainer) && el.tagName !== 'SCRIPT' && !el.inert
			);
			inertElements.forEach((el) => { el.inert = true; });
			window.setupFocusTrap(focusTrap, modalContainer, {
				triggerElement: trigger instanceof HTMLElement ? trigger : null,
				onEscape: () => closeModal(),
				label: 'CountryLanguageModal'
			});
		};

		const closeModal = () => {
			if (!modalContainer.classList.contains('mm-open')) return;
			modalContainer.classList.remove('mm-open');
			html.classList.remove('stop-scrolling');
			inertElements.forEach((el) => { el.inert = false; });
			inertElements = [];
			window.removeFocusTrap(focusTrap, { restoreFocus: true, label: 'CountryLanguageModal' });
		};

		// Listener délégué : gère les déclencheurs ajoutés n'importe où (header/footer/menu mobile)
		document.addEventListener('click', (e) => {
			if (e.target.closest('[data-mm-selector-country-language-open]')) {
				e.preventDefault();
				openModal();
			}
			if (e.target.closest('[data-mm-selector-modal-close]')) {
				closeModal();
			}
		});

		// Echap : gere par le focus trap (onEscape)

		// ─────────────────────────────────────────────────────────────────────
		// Auto-détection au 1er visit — modale uniquement, aucun redirect client.
		// N'ouvre la modale que pour les pays non couverts par un market Shopify.
		// (Les redirections market FR→EN etc. sont configurées côté Admin Shopify.)
		// ─────────────────────────────────────────────────────────────────────
		const STORAGE_KEY = 'mm_localization_applied';
		if (localStorage.getItem(STORAGE_KEY)) return;

		// Ignorer les bots/crawlers
		if (/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)) return;

		const countrySelect = document.getElementById('mm-country-select');
		if (!countrySelect) return;

		const locale = navigator.language || '';
		const parts = locale.split('-');
		const countryCode = parts[1] ? parts[1].toUpperCase() : null;

		// Marquer comme traité pour ne jamais rejouer cette logique pour ce visiteur
		localStorage.setItem(STORAGE_KEY, '1');

		if (countryCode) {
			const countryOption = countrySelect.querySelector('option[value="' + countryCode + '"]');
			if (!countryOption) {
				// Pays absent de tout market Shopify → ouvrir la modale après 5s
				setTimeout(openModal, 5000);
			}
			// Si le pays EST dans un market : Shopify Markets gère le redirect server-side
		}
	});
})();
